import { Button } from '#/components/ui/button';
import { Link } from 'react-router';

import { buttonStyles } from '../styles';
import { SvgIconExchangeTicket } from '../svg/icon-exchange-ticket';
import { SvgIconQuestionMark } from '../svg/icon-question-mark';
import { SvgIconQuestionMarkLight } from '../svg/icon-question-mark-light';
import { SvgGuideIllustContents } from '../svg/img-guide-illust-contents';
import { SvgGuideIllustFamily } from '../svg/img-guide-illust-family';
import { SvgGuideNavIconCart } from '../svg/img-guide-nav-icon-cart';
import { SvgGuideNavIconDevice } from '../svg/img-guide-nav-icon-device';
import { SvgGuideServiceFlow } from '../svg/img-guide-service-flow';
import { SiteDrawerTicketDescription } from './site-drawer-ticket-description';

export const SiteGuideList = () => {
  return (
    <ul>
      <li className="mb-[136px] block justify-between" id="service">
        <div className="mb-8">
          <SvgGuideNavIconDevice className="mx-auto mb-2 w-[56px]" aria-label="サイトを通るだけで株がもらえる" />
          <p className="text-body-s-bold text-brand text-center">サイトを通るだけで株がもらえる</p>
        </div>
        <div className="w-full overflow-x-visible">
          <h2 className="text-headline-xl mb-8 text-center !tracking-[0.02em]">
            カブ活サイトを通って
            <br />
            サービスを利用するだけ
            <br />
            で株がもらえる。
          </h2>
          <SvgGuideServiceFlow
            className="-mb-12 ml-[-10%] h-auto w-[120%] max-w-none"
            aria-label="カブ活サービスフロー"
          />
          <p className="text-body-m mb-4 w-full text-justify">
            カブ活サイトを経由して、いつものお買い物やゲームのインストール・サービス利用等を行い、獲得条件をクリアすると株引換券がもらえます。
          </p>
          <div className="text-caption-m mb-10">
            <SiteDrawerTicketDescription
              trigger={
                <button
                  className="text-caption-m item-center flex gap-1 rounded-xs text-blue-600 decoration-inherit outline-blue-500"
                  type="button">
                  株引換券とは
                  <SvgIconQuestionMark className="size-4 flex-none text-blue-600" aria-label="株引換券とは" />
                </button>
              }
            />
          </div>
        </div>

        <div className="bg-grey-50 relative mb-8 overflow-hidden rounded-2xl px-4 pt-8 pb-4">
          <h3 className="text-headline-m mb-4 tracking-[0.02em]">
            たとえば、
            <br />
            <span className="whitespace-nowrap">5%のショップで10,000円の</span>
            <br />
            お買い物をすると？
          </h3>
          <SvgGuideIllustFamily
            className="static top-[200px] -right-2 mx-auto h-auto w-[250px]"
            aria-label="カブ活イラスト"
          />
          <div className="mt-4 mb-4 w-full rounded-lg bg-white px-8 py-10">
            <SiteDrawerTicketDescription
              trigger={
                <button className="border-grey-100 text-caption-m-bold mb-6 flex w-full items-center border-b py-2">
                  <SvgIconExchangeTicket className="mr-1 inline size-4" aria-label="もらえる株引換券" />
                  もらえる株引換券
                  <SvgIconQuestionMarkLight
                    className="text-grey-400 ml-auto inline-block size-4 flex-none"
                    aria-label="株引換券とは"
                  />
                </button>
              }
            />
            <div className="w-full">
              <p className="text-body-m-bold text-brand mb-2">
                <span className="align-[-0.1em] text-[40px]">500</span>
                枚もらえる
              </p>
              <p className="text-body-s">
                166株相当
                <span className="align-text-bottom text-[0.6rem]">※</span>
              </p>
            </div>
          </div>
          <small className="text-caption-m text-grey-900 before:text-caption-m relative mb-4 block pl-6 before:absolute before:left-0 before:content-['※']">
            株数相当の数は、各株引換券の枚数を、カブアンド種類株式第1期募集の発行価格（1株3円）で除し、端数調整を行うことにより算出した予定数であり、カブアンド種類株式第2期募集以降の募集に応じて株式を取得する場合における取得株式数はこれとは異なる可能性があります。とりわけカブアンド種類株式第2期募集の発行価格は、2025年4月22日における、第三者評価機関によるカブアンド種類株式の評価額を基準とした3～6円（2025年10月28日に最終的に決定する発行価格とは乖離する可能性があります。）を見込んでおりますので、カブアンド種類株式第2期募集に応じて実際に取得できる株数は、表示されている株数相当の数よりも下回る可能性が相当程度高いです。詳細は各募集に係る目論見書をご確認ください。
          </small>
        </div>
        <Link to="/" className="mx-auto mb-[122px] block w-[250px]">
          <Button className={buttonStyles.default.lg}>さっそくカブ活をする</Button>
        </Link>
      </li>
      <li className="mb-[136px] block justify-between" id="contents">
        <div className="mb-8">
          <SvgGuideNavIconCart className="mx-auto mb-2 size-[56px]" aria-label="幅広いコンテンツ" />
          <p className="text-body-s-bold text-brand text-center">幅広いコンテンツ</p>
        </div>
        <div className="w-full">
          <h2 className="text-headline-xl mb-8 text-center">
            ネットショップや
            <br />
            <span className="tracking-[-0.02em] whitespace-nowrap">ゲーム・月額サービスなど</span>
            <br />
            幅広いコンテンツから
            <br />
            選び放題。
          </h2>
          <SvgGuideIllustContents
            className="-mb-8 ml-[-4.5%] block h-auto w-[109%] max-w-none"
            aria-label="カブ活イラスト"
          />
          <p className="text-body-m mb-8 w-full text-justify">
            KABU&カブ活では、日用品のお買い物から、趣味の雑貨やゲームまで、幅広いコンテンツから選べます。
          </p>
        </div>
        <Link to="/" className="mx-auto mb-[122px] block w-[250px]">
          <Button className={buttonStyles.default.lg}>コンテンツを探す</Button>
        </Link>
      </li>
    </ul>
  );
};
